<template>
    <div class="authenticate text-xs-center">
      <router-view></router-view>

      <v-layout row>
        <v-flex xs12>
          <router-link to="/">
            <v-btn @click="checkLoggedInUsers" color="blue">Ingelogd?</v-btn>
          </router-link>
        </v-flex>
      </v-layout>

    </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'auth',
    methods: {
      checkLoggedInUsers () {
        firebase.auth().onAuthStateChanged(function (user) {
          if (user) {
            console.log(user)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Auth.vue?72d9794a